export const allowedLanguages = ['en', 'fr', 'es', 'de', 'it', 'id', 'ru', 'pt']